<template>
  <FormItem
    class="address-select"
    v-bind="{label, labelWidth, prop}"
  >
    <Row>
      <Col 
        :xs="12" 
        :md="6"
      >
        <VueSelect
          class="base-vue-select hide-clear"
          label="name"
          max-height="200px"
          :value="val.city"
          :options="cities"
          :on-change="handleCityChange"
        />
      </Col>
      <Col
        class="area-col"
        :xs="12"
        :md="6"
      >
        <VueSelect
          class="base-vue-select hide-clear"
          label="name"
          max-height="200px"
          :value="val.area"
          :options="areas"
          :on-change="handleAreaChange"
        >
          <span slot="no-options">請先選擇縣市</span>
        </VueSelect>
      </Col>
      <Col 
        :xs="24" 
        :md="12"
      >
        <Input
          :value="val.road"
          size="large"
          @on-change="handleRoadChange($event)"
        />
      </Col>
    </Row>
    <p v-if="tips">{{ tips }}</p>
  </FormItem>
</template>

<script>
  import { FormItem, Input, Row, Col } from 'iview';
  import VueSelect from 'vue-select';
  import cities from '@/staticData/addressDropdown';

  export default {
    components: { FormItem, Input, VueSelect, Row, Col },
    props: {
      prop: {
        type: String,
        default: null
      },
      label: {
        type: String,
        default: '通訊地址'
      },
      labelWidth: {
        type: Number,
        default: null
      },
      tips: {
        type: String,
        default: null
      },
      value: {
        type: Object,
        default: () => ({ city: '台北市', area: '信義區', road: '', zip: '' })
      }
    },
    data() {
      return {
      };
    },
    computed: {
      val() {
        const { value, cities, areas } = this;
        return Object.keys(value).reduce((acc, key) => {
          const val = value[key];
          if (key === 'city') {
            const cityVal = cities.find(city => city.name === val) || '';
            return { ...acc, [key]: cityVal };
          }
          if (key === 'area') {
            const areaVal = areas.find(area => area.name === val) || '';
            return { ...acc, [key]: areaVal };
          }
          return { ...acc, [key]: val };
        }, {});
      },
      cities() { return cities; },
      areas() {
        const { city: cityName } = this.value;
        if (!cityName) return [];
        const { areas } = cities.find(city => city.name === cityName);
        return areas;
      }
    },
    methods: {
      handleCityChange(optionObj) {
        const { value } = this;
        // if (!optionObj) {
        //   const address = { ...value, city: '', area: '', zip: '' };
        //   this.$emit('input', address);
        // }
        const { name } = optionObj;
        this.$emit('input', { ...value, city: name });
      },
      handleAreaChange(optionObj) {
        const { value } = this;
        const { name, zip } = optionObj;
        const address = { ...value, zip, area: name };
        this.$emit('input', address);
      },
      handleRoadChange(e) {
        const { value } = this;
        const road = e.target.value;
        const address = { ...value, road };
        this.$emit('input', address);
      }
    }
  };
</script>